export const translations = {
  en: {
    nav: {
      about: "About",
      news: "News",
      publications: "Publications",
      awards: "Awards",
      contact: "Contact",
    },
    hero: {
      viewCv: "CV",
      scholar: "Google Scholar",
      email: "Email",
      github: "GitHub",
    },
    sections: {
      about: "About",
      news: "News",
      publications: "Publications",
      awards: "Awards",
      contact: "Contact",
    },
    publications: {
      international: "International Journals & Conferences (Peer-Reviewed)",
      posters: "International Conferences (Posters & Demos, Peer-Reviewed)",
      domesticPeerReviewed: "Domestic Journals & Conferences (Peer-Reviewed)",
      domesticNonPeerReviewed: "Domestic Conferences (Non-Peer-Reviewed)",
      paperLink: "Link",
    },
    news: {
      viewAll: "See all",
    },
    contact: {
      label: "Email",
      note: "Feel free to reach out with any questions or thoughts.",
    },
    footer: "© Yuki Nakagawa",
    langToggle: "日本語",
  },
  ja: {
    nav: {
      about: "About",
      news: "News",
      publications: "Publications",
      awards: "Awards",
      contact: "Contact",
    },
    hero: {
      viewCv: "CV",
      scholar: "Google Scholar",
      email: "Email",
      github: "GitHub",
    },
    sections: {
      about: "About",
      news: "News",
      publications: "Publications",
      awards: "Awards",
      contact: "Contact",
    },
    publications: {
      international: "国際論文誌・国際会議（査読あり）",
      posters: "国際会議（ポスター・デモ、査読あり）",
      domesticPeerReviewed: "国内論文誌・会議（査読あり）",
      domesticNonPeerReviewed: "国内会議（査読なし）",
      paperLink: "リンク",
    },
    news: {
      viewAll: "すべて見る",
    },
    contact: {
      label: "メール",
      note: "ご質問やご連絡など、お気軽にお問い合わせください。",
    },
    footer: "© 中川 由貴",
    langToggle: "English",
  },
};
